const Productdata=[
    {
        id: 1,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FZRynchJY%2FGreen-Leaf-Lettuce-each.jpg&w=256&q=75",
        title: "Green Leaf Lettuce",
        desc: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humor, or randomized words which don't look even slightly believable. If you are going to use a passage of",
        price: "$14",
      },
      {
        id: 2,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FMTPyNwQC%2FClementine-5ct.jpg&w=256&q=75",
        title: "Clementine",
        desc: "Josefa Queen Size Bed with Storage in Natural Teak Wood Finish There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even",
        price: "$13",
      },
      {
        id: 3,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FqRpDcpsy%2FRainbow-Peppers-4ct.jpg&w=256&q=75",
        title: "Rainbow Peppers",
        desc: "It is a long-established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters Many",
        price: "$19",
      },
      {
        id: 4,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FL8L3XGcP%2FBlackberries-1-25-qt.jpg&w=256&q=75",
        title: "Blueberry",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$15"
      },
      {
        id: 5,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FbvrsZtMt%2FCalabaza-Squash-Package-each.jpg&w=256&q=75",
        title: "DCalabaza Squash",
        desc:"Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes",
        price:"$15"
      },
      {
        id: 6,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FGhRtkNVr%2FLettuce-1lb.jpg&w=256&q=75",
        title: "Lettuce",
        desc:"Bonorum et Malorum (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit,",
        price:"$11"
      },
      {
        id: 7,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2F5y7rNDFv%2FRadicchio-12ct.jpg&w=256&q=75",
        title: "Radicchio",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia,",
        price:"$12"
      },
      {
        id: 8,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FwvzZWXpt%2FParsley-each.jpgg&w=256&q=75",
        title: "Parsley",
        desc:"There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of",
        price:"$19"
      },
      {
        id: 9,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FNFXkHVKZ%2FStrawberries-9-25oz.jpg&w=256&q=75",
        title: "Strawberrie",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$18"
      },
      {
        id: 10,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FvHwg0D1J%2FCauliflower-1-35lb.jpg&w=256&q=75",
        title: "Cauliflower",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$20"
      },
      {
        id: 11,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2F9FN3WwGS%2FOrganic-Purple-Cauliflower-1lb.jpg&w=256&q=75",
        title: "Organic Purple Cauliflower",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$10"
      },
      {
        id: 12,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FcJL8fjK6%2FAhold-Acorn-Squash-1ct.jpg&w=256&q=75",
        title: "Ahold Acorn Squash",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$12"
      },
      {
        id: 13,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2Fd3r7qcfN%2FBok-Choy-Cabbage-per-lb.jpg&w=256&q=75",
        title: "Bok Choy Cabbage",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$19"
      },
      {
        id: 14,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FFstZ49qv%2FStrawberries-Package-2-25-oz.jpg&w=256&q=75",
        title: "Strawberries Package",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$10"
      },
      {
        id: 15,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FN0C2D4TD%2FAloe-Vera-Leaf-each.jpg&w=256&q=75",
        title: "Aloe Vera Leaf",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$15"
      },
      {
        id: 16,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2F8Ck40tYr%2FPineapple-1-5lb.jpg&w=256&q=75",
        title: "Pineapple Imported",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$18"
      },
      {
        id: 17,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2F3w03MCVn%2FOrganic-Broccoli-10oz.jpg&w=256&q=75",
        title: "Organic Broccoli",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$12"
      },
      {
        id: 18,
        img: "https://kachabazar-store.vercel.app/_next/image?url=https%3A%2F%2Fi.postimg.cc%2FDZdkFCgd%2FOrganic-Pinkerton-Avocado-each.jpg&w=256&q=75",
        title: "Organic Pinkerton Avocado",
        desc:"Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.",
        price:"$14"
      },
 
     
      


]


export default Productdata;